import { FC, useContext, useState } from 'react';
import { dateFormat } from 'utils/shared/utils';
import withErrorBoundary from '../../withErrorBoundary';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import FreeTextModal from '../Single/FreeTextModal';
import { faPenToSquare } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import { MainContext } from 'contexts/MainContext';

interface TicketProposalProps {
  ticket: any;
  price?: string;
  dynamicIndex: number;
}

const TicketProposal: FC<TicketProposalProps> = ({ ticket, ...props }) => {
  const [showFreeModal, setShowFreeModal] = useState(false);
  const { proposal, setProposal, cdnUrl } = useContext(MainContext);
  const { t } = useTranslation();
  const onSaveFreeText = (desc: string, displayOrder?: number) => {
    setProposal({
      ...proposal,
      dynamic: proposal.dynamic.map((f, i) =>
        i === props.dynamicIndex ? { ...f, freeTextTicket: desc, displayOrder } : f
      ),
    });
  };
  return (
    <div>
      <div className="pr-hotel-head text-bold flex-between">
        <span>{t('dyn.ticket')}</span>
        <div>
          <FontAwesomeIcon onClick={() => setShowFreeModal(true)} icon={faPenToSquare} />
        </div>
      </div>
      <div className="pr-ticket">
        <div className="pr-ticket-logo">
          <img src={ticket.image} alt="1" />
        </div>
        <div className="pr-ticket-info">
          <div>
            <div className="pr-ticket-title">
              <span className="pr-ticket-title-1">{ticket.showName.split(' - ')?.[0]}</span>
              <span> - </span>
              <span className="pr-ticket-title-2">{ticket.showName.split(' - ')?.[1]}</span>
            </div>
            <div>{ticket.categoryDesc}</div>
            <div>
              {ticket.city}, {ticket.country}
            </div>
            <div className="">{ticket.tickets[0].ticket.vanueDesc}</div>
            <div className="text-sm text-black">{ticket.tickets[0].ticket.ticketDesc}</div>
          </div>
        </div>
        <div className="ml-a"></div>

        <div className="pr-ticket-total">
          <div className="pr-ticket-total-images">
            {!!ticket.tickets[0].team1Logo && (
              <div className="pr-ticket-img">
                <img
                  src={cdnUrl + ticket.tickets[0].team1Logo}
                  alt="1"
                  className="img-box-shadow"
                />
              </div>
            )}
            {!!ticket.tickets[0].team2Logo && (
              <div className="pr-ticket-img">
                <img
                  src={cdnUrl + ticket.tickets[0].team2Logo}
                  alt="1"
                  className="img-box-shadow"
                />
              </div>
            )}
            {!!ticket.categoryImage && (
              <div className="pr-ticket-cat">
                <img src={ticket.categoryImage.imageLink} alt="1" className="img-box-shadow" />
              </div>
            )}
          </div>

          <div className="pr-ticket-total-date">
            {dateFormat(ticket.eventDate, 'dd/MM/yyyy - HH:mm')}
          </div>
        </div>
      </div>
      {showFreeModal && (
        <FreeTextModal
          close={() => setShowFreeModal(false)}
          onSave={onSaveFreeText}
          displayOrder={proposal.dynamic[props.dynamicIndex].displayOrder}
          freeText={proposal.dynamic[props.dynamicIndex].freeTextTicket || ''}
        />
      )}
    </div>
  );
};

export default withErrorBoundary(TicketProposal, 'TicketProposal');
